const objectValueNotZero = (obj) => !!obj && !!obj.value && parseInt(obj.value, 10) !== 0;

export default objectValueNotZero;
